import React, { FC } from 'react';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import { MainValue, Value } from '../components';
import { WidgetDataColour } from './colours';

export const AsPlanned: FC<{ translationKey: TranslationKey }> = ({
  translationKey,
}) => (
  <Value>
    {useTranslation(translationKey, {
      span: (chunks) => (
        <MainValue color={WidgetDataColour.Green}>{chunks}</MainValue>
      ),
    })}
  </Value>
);
